import { Box, createTheme, Typography, useMediaQuery } from "@mui/material";
import React, { use, useContext, useEffect, useState } from "react";
import logo from "../assets/logo_s.png";
import map from "../assets/map-removebg-preview.png";
import Hil from "./Modal/Hil";
import HugatsaatLawlagaa from "./Modal/Arhiv4";
import { Image } from "@mui/icons-material";
import maphil from "../assets/neg.png";
import mapblue from "../assets/mgl.png";
import hoyr from "../assets/2.png";
import guraw from "../assets/3.png";
import duruv from "../assets/4.png";
import tav from "../assets/5.png";
import zurgaa from "../assets/6.png";
import naim from "../assets/8.png";
import ys from "../assets/9-removebg-preview.png";
import Gadaad from "./Modal/Gadaad";
import Arhiv1 from "./Modal/Arhiv1";
import Arhiv2 from "./Modal/Arhiv2";
import Arhiv3 from "./Modal/Arhiv3";
import Arhiv4 from "./Modal/Arhiv4";
import Boomt from "./Modal/Boomt";
import Ulsinhil from "./Modal/Ulsinhil";
import mongolbichig from "./../assets/mb.png";
const drawerWidth = 50;
const COLORS = ["#fe0000ff", "#0042f7ff", "#FFBB28", "#FF8042", "#A28DFF"];
const MainActivity = ({
  cyberdata,
  plandata,
  zaswardata,
  programmdata,
  mtdata,
  holboodata,
}) => {
  const [one, setOne] = useState(false);
  const [two, setTwo] = useState(false);
  const [three, setThree] = useState(false);
  const [four, setFour] = useState(false);
  const [five, setFive] = useState(false);
  const [six, setSix] = useState(false);
  const [seven, setSeven] = useState(false);
  const [eight, setEight] = useState(false);
  // const [on]
  const cardStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "22px",
    background: "rgba(255,255,255,0.08)",
    backgroundImage:
      "linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.05) 100%)",
    border: "1px solid rgba(255,255,255,0.18)",
    backdropFilter: "blur(18px) saturate(180%)",
    WebkitBackdropFilter: "blur(18px) saturate(180%)",
    boxShadow: "0 8px 32px rgba(0,0,0,0.37)",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "#fff",
    transition: "all 0.35s ease",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "22px",
      padding: "2px",
      background: "linear-gradient(90deg, #6bbcff, #ffffff, #6bbcff)",
      opacity: 0,
      transition: "opacity 0.4s ease",
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
    },
    "&:hover::before": {
      opacity: 1,
    },
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 18px 50px rgba(0,0,0,0.55)",
    },
  };
  return (
    <Box sx={{ width: "100%" }} m="0">
      <Box>
        <Box
          display="grid"
          gridTemplateColumns="repeat(16, 1fr)"
          gridAutoRows="200px"
          sx={{ opacity: "0.9" }}
          gap="20px"
          m="5"
          p={2}
        >
          <Box gridColumn="span 2" gridRow="span 4">
            <Box
              component="img"
              src={mongolbichig}
              alt="logo"
              sx={{ width: "70%" }}
            ></Box>
          </Box>
          <Box gridColumn="span 5" gridRow="span 1">
            <Box
              sx={{
                display: "flex",
                gridTemplateColumns: "repeat(2, 1fr)",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{ width: 100, mr: 2 }}
              >
                {/* <Image src={logo} width={50} height={50} /> */}
              </Box>
              <Box sx={{ marginRight: 2 }}>
                <Box
                  sx={{
                    color: "#ffffffff",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: 12,
                    mt: "clamp(8px, 2vw, 32px)",
                  }}
                >
                  ЗАСГИЙН ГАЗРЫН
                  <br /> ХЭРЭГЖҮҮЛЭГЧ АГЕНТЛАГ
                </Box>
                <Box
                  sx={{
                    color: "#ffffffff",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: 20,
                    mt: -3,
                  }}
                >
                  <br /> ХИЛ ХАМГААЛАХ
                  <br />
                  ЕРӨНХИЙ ГАЗАР
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            gridColumn="span 9"
            gridRow="span 1"
            sx={{
              color: "#ffffffff",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 20,
              mt: 5,
              textShadow: "0 0 6px #000000c4, 0 0 12px #000000c4",
              //text-shadow: 0 0 8px #ffffffc4, 0 0 16px #ffffffc4;
            }}
          >
            ХИЛ ХАМГААЛАХ БАЙГУУЛЛАГААС ИРГЭН, АЖ АХУЙН НЭГЖИД
            <br />
            ОЛГОДОГ ҮЙЛЧИЛГЭЭГ И-МОНГОЛИА СИСТЕМЭЭР АВАХ ЗААВАР
          </Box>
          <Box gridColumn="span 2" gridRow="span 1"></Box>

          <Box
            gridColumn="span 8"
            gridRow="span 2"
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "visible",

              "&::after": {
                content: '""',
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                height: "90%",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(0,150,255,0.6), transparent)",
                filter: "blur(70px)",
                zIndex: 0,
                animation: "pulseGlow 2.5s infinite ease-in-out",
              },

              "@keyframes pulseGlow": {
                "0%": {
                  opacity: 0.3,
                  transform: "translate(-50%, -50%) scale(0.9)",
                },
                "50%": {
                  opacity: 1,
                  transform: "translate(-50%, -50%) scale(1.1)",
                },
                "100%": {
                  opacity: 0.3,
                  transform: "translate(-50%, -50%) scale(0.9)",
                },
              },
            }}
          >
            {/* <Box
            component="img"
            src={mapblue}
            sx={{
              width: "100%",
              height: 500,
              position: "relative",
              zIndex: 2,
              objectFit: "contain",
            }}
          /> */}
            <Box
              sx={{
                width: "100%",
                height: 500,
                position: "relative",
                zIndex: 2,
                objectFit: "contain",
                top: "-20%",
              }}
            >
              {/* Image */}
              <Box
                component="img"
                src={mapblue}
                alt="map"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />

              {/* Centered text */}
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#040d94ff",
                  fontSize: {
                    xs: "14px", // mobile
                    sm: "18px", // tablet
                    md: "24px", // laptop
                    lg: "28px", // desktop
                  },
                  fontWeight: "bold",
                  textAlign: "center",
                  textShadow: "0 0 8px #00f80cc4, 0 0 16px #00f80cc4",
                  pointerEvents: "none",
                  animation: "glow-rotate 3s linear infinite",
                  "@keyframes glow-rotate": {
                    "0%": {
                      textShadow:
                        "0 0 4px #7eff5ec4, 0 0 8px #7eff5ec4, 0 0 16px rgba(255, 255, 255, 0.5), 0 0 32px rgba(255, 255, 255, 0.5)",
                    },
                    "50%": {
                      textShadow:
                        "0 0 4px rgba(0, 0, 0, 0.3), 0 0 8px rgba(0, 0, 0, 0.3), 0 0 16px rgba(255, 255, 255, 0.7), 0 0 32px rgba(255, 255, 255, 1)",
                    },
                    "100%": {
                      textShadow:
                        "0 0 4px #7eff5ec4, 0 0 8px #7eff5ec4, 0 0 16px rgba(255, 255, 255, 0.5), 0 0 32px rgba(255, 255, 255, 0.5)",
                    },
                  },
                }}
              >
                МОНГОЛ УЛСЫН ХИЛ ТАЙВАН БАЙНА
              </Box>
            </Box>
          </Box>

          <Box gridColumn="span 4" gridRow="span 1"></Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setOne(true)}
            sx={cardStyle}
          >
            {/* <Image src={maphil} width={50} height={50} /> */}
            <Box
              component="img"
              src={maphil}
              alt="logo"
              sx={{ width: 30, mb: 1 }}
            />
            <Typography sx={{ fontWeight: 200 }}>
              Хилийн бүс нутагт
              <br /> нэвтрэх зөвшөөрөл
            </Typography>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setEight(true)}
            sx={cardStyle}
          >
            <Box
              component="img"
              src={naim}
              alt="logo"
              sx={{ width: 34, mb: 1 }}
            />

            <Typography
              sx={{ fontWeight: 300, fontSize: "14px", lineHeight: "20px" }}
            >
              Хугацаат цэргийн алба
              <br />
              хаасан тухай
              <br />
              лавлагаа
            </Typography>
          </Box>
          <Box gridColumn="span 2" gridRow="span 1"></Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setTwo(true)}
            sx={cardStyle}
          >
            <Box
              component="img"
              src={hoyr}
              alt="logo"
              sx={{ width: 30, mb: 1 }}
            />
            <Typography sx={{ fontWeight: 200 }}>
              Хилийн боомтод
              <br /> нэвтрэх
              <br /> зөвшөөрөл
            </Typography>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setThree(true)}
            sx={cardStyle}
          >
            <Box
              component="img"
              src={tav}
              alt="logo"
              sx={{ width: 30, mb: 1 }}
            />
            <Typography sx={{ fontWeight: 200 }}>
              Гадаад улсад
              <br /> зорчих эрхийн
              <br /> лавлагаа
            </Typography>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setFour(true)}
            sx={cardStyle}
          >
            <Box
              component="img"
              src={ys}
              alt="logo"
              sx={{ width: 30, mb: 1, backgroundColor: "#ffffff" }}
            />
            <Typography sx={{ fontWeight: 200 }}>
              Улсын хилээр
              <br /> нэвтэрсэн иргэний
              <br /> лавлагаа
            </Typography>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setFive(true)}
            sx={cardStyle}
          >
            <Box
              component="img"
              src={duruv}
              alt="logo"
              sx={{ width: 30, mb: 1 }}
            />
            <Typography sx={{ fontWeight: 200 }}>
              Ажилласан
              <br /> жилийн
              <br /> лавлагаа
            </Typography>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setSix(true)}
            sx={cardStyle}
          >
            <Box
              component="img"
              src={guraw}
              alt="logo"
              sx={{ width: 30, mb: 1 }}
            />
            <Typography sx={{ fontWeight: 200 }}>
              Цалингийн
              <br /> лавлагаа
            </Typography>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            onClick={() => setSeven(true)}
            sx={cardStyle}
          >
            <Box
              component="img"
              src={zurgaa}
              alt="logo"
              sx={{ width: 30, mb: 1 }}
            />
            <Typography sx={{ fontWeight: 200 }}>
              Тушаал шийдвэр,
              <br /> бусад баримтын
              <br /> хуулбар авах
            </Typography>
          </Box>
          <Box gridColumn="span 2" gridRow="span 1"></Box>
        </Box>
        {/* MODAL */}
        <Hil one={one} onClose={() => setOne(false)} />
        <Boomt two={two} onClose={() => setTwo(false)} />
        <Gadaad three={three} onClose={() => setThree(false)} />
        <Ulsinhil four={four} onClose={() => setFour(false)} />
        <Arhiv1 five={five} onClose={() => setFive(false)} />
        <Arhiv2 six={six} onClose={() => setSix(false)} />
        <Arhiv3 seven={seven} onClose={() => setSeven(false)} />
        <Arhiv4 eight={eight} onClose={() => setEight(false)} />
      </Box>
    </Box>
  );
};

export default MainActivity;
